import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  Container,
  Grid,
  Paper,
  Card,
  CardContent,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tabs,
  Tab,
  Tooltip,
  IconButton,
  Stack,
  // Button, // Kullanılmadığı için yorum satırına alındı
  Chip,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Rating,
  // TextField, // Kullanılmadığı için yorum satırına alındı
  Avatar,
  AvatarGroup
  // Badge // Kullanılmadığı için yorum satırına alındı
} from '@mui/material';
import {
  LineChart,
  Line,
  // BarChart, // Kullanılmadığı için yorum satırına alındı
  // Bar, // Kullanılmadığı için yorum satırına alındı
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar
  // Area, // Kullanılmadığı için yorum satırına alındı
  // AreaChart // Kullanılmadığı için yorum satırına alındı
} from 'recharts';
import RefreshIcon from '@mui/icons-material/Refresh';
import CampaignIcon from '@mui/icons-material/Campaign';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
// import TrendingDownIcon from '@mui/icons-material/TrendingDown'; // Kullanılmadığı için yorum satırına alındı
import GroupsIcon from '@mui/icons-material/Groups';
// import AddIcon from '@mui/icons-material/Add'; // Kullanılmadığı için yorum satırına alındı
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Kullanılmadığı için yorum satırına alındı
import BarChartIcon from '@mui/icons-material/BarChart';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AnimatedNumber from '../../components/common/AnimatedNumber';

// Renk paleti
const COLORS = ['#4caf50', '#ff9800', '#f44336', '#3f51b5', '#9c27b0', '#e91e63', '#2196f3', '#00bcd4'];

// Kampanya özet verileri
const campaignSummary = {
  activeCount: 8,
  completedCount: 12,
  plannedCount: 3,
  totalReach: 352750,
  totalConversions: 41820,
  totalRevenue: 1850000,
  avgRoi: 324,
  avgConversionRate: 11.85,
  lastMonthGrowth: 14.5
};

// Kampanya kanal dağılımı
const channelDistribution = [
  { name: 'E-posta', value: 45 },
  { name: 'SMS', value: 20 },
  { name: 'Push Bildirim', value: 15 },
  { name: 'Sosyal Medya', value: 10 },
  { name: 'Web Banner', value: 10 }
];

// Müşteri segmentleri
const customerSegments = [
  { id: 1, name: 'Yüksek Değerli', customerCount: 12500, color: '#4caf50' },
  { id: 2, name: 'Orta Değerli', customerCount: 45000, color: '#2196f3' },
  { id: 3, name: 'Yeni Müşteriler', customerCount: 18500, color: '#ff9800' },
  { id: 4, name: 'Risk Altındaki', customerCount: 7500, color: '#f44336' },
  { id: 5, name: 'Uykuda', customerCount: 24000, color: '#9c27b0' }
];

// Kampanya performans eğilimi
const generatePerformanceTrend = () => {
  const months = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];
  const currentMonth = new Date().getMonth();
  
  const last12Months = Array.from({ length: 12 }, (_, i) => {
    const monthIndex = (currentMonth - 11 + i) % 12;
    return months[monthIndex >= 0 ? monthIndex : monthIndex + 12];
  });

  return last12Months.map((month, index) => {
    // Her ay için artan bir trendi simüle et, dalgalanmalarla birlikte
    const baseConversionRate = 5 + (index * 0.6) + Math.random() * 2; // 5% ile başlayıp artarak devam ediyor
    const baseRevenue = 800000 + (index * 60000) + Math.random() * 100000; // Temel gelir artışı
    
    return {
      month,
      conversionRate: parseFloat(baseConversionRate.toFixed(2)),
      revenue: Math.round(baseRevenue / 1000) * 1000, // 1000'e yuvarla
      campaignCount: Math.round(1 + index / 2 + Math.random() * 2) // Kampanya sayısı
    };
  });
};

// Kampanya listesi
const generateCampaigns = () => {
  const campaignTypes = ['İndirim', 'Sadakat', 'Ürün Tanıtım', 'Geri Kazanım', 'Çapraz Satış'];
  const channels = ['E-posta', 'SMS', 'Push Bildirim', 'Sosyal Medya', 'Web Banner'];
  const statuses = ['Aktif', 'Tamamlandı', 'Planlandı'];
  
  return Array.from({ length: 20 }, (_, i) => {
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const startDate = new Date();
    const endDate = new Date();
    
    // Tamamlanmış kampanyalar için geçmiş tarihler
    if (status === 'Tamamlandı') {
      startDate.setMonth(startDate.getMonth() - 3 - Math.floor(Math.random() * 3)); // 3-6 ay önce başlamış
      endDate.setMonth(startDate.getMonth() + 1 + Math.floor(Math.random() * 2)); // 1-3 ay sürmüş
    }
    // Aktif kampanyalar için mevcut tarihler
    else if (status === 'Aktif') {
      startDate.setDate(startDate.getDate() - 10 - Math.floor(Math.random() * 20)); // 10-30 gün önce başlamış
      endDate.setDate(startDate.getDate() + 20 + Math.floor(Math.random() * 40)); // 20-60 gün sürecek
    }
    // Planlanmış kampanyalar için gelecek tarihler
    else {
      startDate.setDate(startDate.getDate() + 5 + Math.floor(Math.random() * 30)); // 5-35 gün sonra başlayacak
      endDate.setDate(startDate.getDate() + 15 + Math.floor(Math.random() * 45)); // 15-60 gün sürecek
    }
    
    const selectedSegments = [];
    const segmentCount = 1 + Math.floor(Math.random() * 3); // 1-3 segment seç
    
    for (let j = 0; j < segmentCount; j++) {
      const randomSegment = customerSegments[Math.floor(Math.random() * customerSegments.length)];
      if (!selectedSegments.some(s => s.id === randomSegment.id)) {
        selectedSegments.push(randomSegment);
      }
    }
    
    const channelsUsed = [];
    const channelCount = 1 + Math.floor(Math.random() * 3); // 1-3 kanal seç
    
    for (let j = 0; j < channelCount; j++) {
      const randomChannel = channels[Math.floor(Math.random() * channels.length)];
      if (!channelsUsed.includes(randomChannel)) {
        channelsUsed.push(randomChannel);
      }
    }
    
    const reach = Math.floor(5000 + Math.random() * 45000);
    const conversionRate = parseFloat((5 + Math.random() * 15).toFixed(2));
    const conversions = Math.floor(reach * conversionRate / 100);
    const revenue = conversions * (500 + Math.random() * 500);
    const cost = reach * (1 + Math.random() * 2);
    const roi = parseFloat((revenue / cost * 100 - 100).toFixed(2));
    
    return {
      id: i + 1,
      name: `${campaignTypes[Math.floor(Math.random() * campaignTypes.length)]} Kampanyası ${i + 1}`,
      type: campaignTypes[Math.floor(Math.random() * campaignTypes.length)],
      status,
      startDate: startDate.toLocaleDateString('tr-TR'),
      endDate: endDate.toLocaleDateString('tr-TR'),
      segments: selectedSegments,
      channels: channelsUsed,
      reach,
      conversions,
      conversionRate,
      revenue,
      cost,
      roi
    };
  }).sort((a, b) => {
    // Duruma göre sırala: Aktif -> Planlandı -> Tamamlandı, sonra ID'ye göre
    const statusOrder = { 'Aktif': 0, 'Planlandı': 1, 'Tamamlandı': 2 };
    if (statusOrder[a.status] !== statusOrder[b.status]) {
      return statusOrder[a.status] - statusOrder[b.status];
    }
    return a.id - b.id;
  });
};

// Müşteri segment analizi
const segmentAnalysis = [
  { subject: 'Satın Alma Sıklığı', 'Yüksek Değerli': 90, 'Orta Değerli': 60, 'Yeni Müşteriler': 30, 'Risk Altındaki': 20, 'Uykuda': 10 },
  { subject: 'Ortalama Sepet', 'Yüksek Değerli': 95, 'Orta Değerli': 70, 'Yeni Müşteriler': 40, 'Risk Altındaki': 35, 'Uykuda': 15 },
  { subject: 'Marka Sadakati', 'Yüksek Değerli': 85, 'Orta Değerli': 65, 'Yeni Müşteriler': 35, 'Risk Altındaki': 30, 'Uykuda': 20 },
  { subject: 'Kampanya Tepkisi', 'Yüksek Değerli': 75, 'Orta Değerli': 60, 'Yeni Müşteriler': 50, 'Risk Altındaki': 45, 'Uykuda': 25 },
  { subject: 'Potansiyel Değer', 'Yüksek Değerli': 80, 'Orta Değerli': 75, 'Yeni Müşteriler': 85, 'Risk Altındaki': 60, 'Uykuda': 40 }
];

// Kanal performans analizi
const channelPerformance = [
  { name: 'E-posta', openRate: 24.5, clickRate: 3.8, conversionRate: 12.5, roi: 380 },
  { name: 'SMS', openRate: 85.2, clickRate: 12.4, conversionRate: 8.7, roi: 220 },
  { name: 'Push Bildirim', openRate: 68.7, clickRate: 8.2, conversionRate: 5.4, roi: 160 },
  { name: 'Sosyal Medya', openRate: 0, clickRate: 1.5, conversionRate: 6.8, roi: 210 },
  { name: 'Web Banner', openRate: 0, clickRate: 0.5, conversionRate: 3.2, roi: 145 }
];

const KampanyaYonetimi = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [campaigns, setCampaigns] = useState([]);
  const [performanceTrend, setPerformanceTrend] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState({
    status: 'all',
    type: 'all',
    segment: 'all'
  });
  
  // Veri yükleme
  useEffect(() => {
    setLoading(true);
    // Simüle edilmiş veri yükleme gecikmesi
    setTimeout(() => {
      setCampaigns(generateCampaigns());
      setPerformanceTrend(generatePerformanceTrend());
      setLoading(false);
    }, 1000);
  }, []);
  
  // Tab değişimi
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  
  // Filtre değişimi
  const handleFilterChange = (key, value) => {
    setFilter({ ...filter, [key]: value });
  };
  
  // Kampanyaları filtrele
  const filteredCampaigns = campaigns.filter(campaign => {
    if (filter.status !== 'all' && campaign.status !== filter.status) return false;
    if (filter.type !== 'all' && campaign.type !== filter.type) return false;
    if (filter.segment !== 'all' && !campaign.segments.some(s => s.id === parseInt(filter.segment))) return false;
    return true;
  });
  
  // Duruma göre renk seçimi
  const getStatusColor = (status) => {
    switch (status) {
      case 'Aktif': return 'success';
      case 'Planlandı': return 'info';
      case 'Tamamlandı': return 'default';
      default: return 'default';
    }
  };
  
  // ROI'ye göre renk seçimi
  const getRoiColor = (roi) => {
    if (roi >= 300) return '#4caf50';
    if (roi >= 200) return '#8bc34a';
    if (roi >= 100) return '#ffeb3b';
    if (roi >= 0) return '#ff9800';
    return '#f44336';
  };
  
  // Kampanya tiplerinin tekil listesi
  const campaignTypes = [...new Set(campaigns.map(c => c.type))];
  
  // Segment bazlı performans verileri
  const generateSegmentPerformance = () => {
    return customerSegments.map(segment => ({
      name: segment.name,
      conversionRate: parseFloat((5 + Math.random() * 15).toFixed(2)),
      roi: Math.round(100 + Math.random() * 400),
      campaignCount: Math.round(2 + Math.random() * 6)
    }));
  };
  
  return (
    <Container maxWidth="lg">
      <Box sx={{ mb: 4 }} className="slide-in-left">
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Kampanya Yönetimi
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          Müşterilerinizi segmente ayırın, etkili pazarlama kampanyaları oluşturun ve performanslarını analiz edin.
        </Typography>
        <Divider sx={{ my: 3 }} />
      </Box>

      {/* Yükleniyor */}
      {loading && (
        <Box sx={{ width: '100%', my: 4 }}>
          <LinearProgress />
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
            Kampanya verileri yükleniyor...
          </Typography>
        </Box>
      )}

      {!loading && (
        <>
          {/* Özet Kartlar */}
          <Grid container spacing={3} sx={{ mb: 4 }}>
            <Grid item xs={12} md={6} lg={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Kampanyalar
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold">
                        <AnimatedNumber
                          value={campaignSummary.activeCount}
                          duration={1500}
                        />
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        aktif kampanya
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: 'primary.main', width: 48, height: 48 }}>
                      <CampaignIcon />
                    </Avatar>
                  </Box>
                  <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                    <Chip
                      size="small"
                      label={`${campaignSummary.completedCount} tamamlandı`}
                      color="default"
                      variant="outlined"
                    />
                    <Chip
                      size="small"
                      label={`${campaignSummary.plannedCount} planlandı`}
                      color="info"
                      variant="outlined"
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={6} lg={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Toplam Erişim
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold">
                        <AnimatedNumber
                          value={campaignSummary.totalReach}
                          duration={1500}
                          formatter={(value) => value.toLocaleString('tr-TR')}
                        />
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {campaignSummary.totalConversions.toLocaleString('tr-TR')} dönüşüm
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: '#ff9800', width: 48, height: 48 }}>
                      <PeopleAltIcon />
                    </Avatar>
                  </Box>
                  <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                      Dönüşüm Oranı:
                    </Typography>
                    <Typography variant="body1" fontWeight="bold" color="primary">
                      {campaignSummary.avgConversionRate}%
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={6} lg={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Toplam Gelir
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold">
                        <AnimatedNumber
                          value={campaignSummary.totalRevenue}
                          duration={1500}
                          formatter={(value) => `₺${value.toLocaleString('tr-TR')}`}
                        />
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        kampanyalardan elde edilen
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: '#4caf50', width: 48, height: 48 }}>
                      <MonetizationOnIcon />
                    </Avatar>
                  </Box>
                  <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
                    <TrendingUpIcon color="success" fontSize="small" sx={{ mr: 0.5 }} />
                    <Typography variant="body2" color="success.main">
                      %{campaignSummary.lastMonthGrowth} artış (önceki aya göre)
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item xs={12} md={6} lg={3}>
              <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                    <Box>
                      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                        Ortalama ROI
                      </Typography>
                      <Typography variant="h4" component="div" fontWeight="bold">
                        <AnimatedNumber
                          value={campaignSummary.avgRoi}
                          duration={1500}
                          suffix="%"
                        />
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        yatırım getirisi
                      </Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: '#3f51b5', width: 48, height: 48 }}>
                      <BarChartIcon />
                    </Avatar>
                  </Box>
                  <Box sx={{ mt: 2, display: 'flex', gap: 1 }}>
                    <Rating 
                      value={4} 
                      readOnly 
                      size="small"
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
      
          {/* Sekmeler */}
          <Paper sx={{ borderRadius: 2, mb: 4 }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="fullWidth"
              sx={{ borderBottom: 1, borderColor: 'divider' }}
            >
              <Tab label="Kampanya Performansı" icon={<BarChartIcon />} iconPosition="start" />
              <Tab label="Müşteri Segmentleri" icon={<GroupsIcon />} iconPosition="start" />
              <Tab label="Kampanya Listesi" icon={<CampaignIcon />} iconPosition="start" />
            </Tabs>
          </Paper>
      
          {/* Sekme İçerikleri */}
          {/* Kampanya Performansı Sekmesi */}
          {activeTab === 0 && (
            <Grid container spacing={4}>
              <Grid item xs={12} lg={8}>
                <Paper sx={{ p: 3, borderRadius: 2, mb: 4, position: 'relative' }}>
                  <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', 
                    background: 'linear-gradient(90deg, #3f51b5, #f50057)' }} />
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Box>
                      <Typography variant="h6">
                        Kampanya Performans Trendi
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Son 12 ay kampanya performansı
                      </Typography>
                    </Box>
                    <Stack direction="row" spacing={1}>
                      <Tooltip title="CSV İndir">
                        <IconButton size="small" sx={{ border: '1px solid #ddd' }}>
                          <FileDownloadIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Yenile">
                        <IconButton size="small" sx={{ border: '1px solid #ddd' }}>
                          <RefreshIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </Box>
                  <Box sx={{ height: 350 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={performanceTrend} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" />
                        <YAxis yAxisId="left" />
                        <YAxis yAxisId="right" orientation="right" />
                        <RechartsTooltip />
                        <Legend />
                        <Line 
                          yAxisId="left"
                          type="monotone" 
                          dataKey="conversionRate" 
                          name="Dönüşüm Oranı (%)" 
                          stroke="#3f51b5" 
                          activeDot={{ r: 8 }} 
                          strokeWidth={2}
                        />
                        <Line 
                          yAxisId="right"
                          type="monotone" 
                          dataKey="revenue" 
                          name="Gelir (₺)" 
                          stroke="#4caf50" 
                          strokeWidth={2}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </Box>
                </Paper>
                
                <Paper sx={{ p: 3, borderRadius: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Kanal Performans Analizi
                  </Typography>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Kanal</TableCell>
                          <TableCell align="right">Açılma Oranı</TableCell>
                          <TableCell align="right">Tıklama Oranı</TableCell>
                          <TableCell align="right">Dönüşüm Oranı</TableCell>
                          <TableCell align="right">ROI</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {channelPerformance.map((row) => (
                          <TableRow key={row.name}>
                            <TableCell component="th" scope="row">
                              {row.name}
                            </TableCell>
                            <TableCell align="right">
                              {row.openRate > 0 ? `${row.openRate}%` : "-"}
                            </TableCell>
                            <TableCell align="right">{row.clickRate}%</TableCell>
                            <TableCell align="right">{row.conversionRate}%</TableCell>
                            <TableCell align="right">
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    fontWeight: 'bold', 
                                    color: getRoiColor(row.roi) 
                                  }}
                                >
                                  {row.roi}%
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
              
              <Grid item xs={12} lg={4}>
                <Stack spacing={4}>
                  <Paper sx={{ p: 3, borderRadius: 2, height: '100%' }}>
                    <Typography variant="h6" gutterBottom>
                      Kanal Dağılımı
                    </Typography>
                    <Box sx={{ height: 300, mt: 2 }}>
                      <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                          <Pie
                            data={channelDistribution}
                            cx="50%"
                            cy="50%"
                            innerRadius={50}
                            outerRadius={90}
                            paddingAngle={2}
                            dataKey="value"
                            label={({name, percent}) => `${name}: ${(percent * 100).toFixed(0)}%`}
                          >
                            {channelDistribution.map((entry, index) => (
                              <Cell 
                                key={`cell-${index}`} 
                                fill={COLORS[index % COLORS.length]} 
                              />
                            ))}
                          </Pie>
                          <RechartsTooltip />
                        </PieChart>
                      </ResponsiveContainer>
                    </Box>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="body2" color="text.secondary">
                      Farklı kanalların kampanyalarda kullanım oranları
                    </Typography>
                  </Paper>
                  
                  <Paper sx={{ p: 3, borderRadius: 2 }}>
                    <Typography variant="h6" gutterBottom>
                      Segment Bazlı Performans
                    </Typography>
                    <TableContainer sx={{ maxHeight: 220 }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Segment</TableCell>
                            <TableCell align="right">Dönüşüm</TableCell>
                            <TableCell align="right">ROI</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {generateSegmentPerformance().map((row) => (
                            <TableRow key={row.name}>
                              <TableCell component="th" scope="row">
                                {row.name}
                              </TableCell>
                              <TableCell align="right">{row.conversionRate}%</TableCell>
                              <TableCell align="right">
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                  <Typography 
                                    variant="body2" 
                                    sx={{ 
                                      fontWeight: 'bold', 
                                      color: getRoiColor(row.roi) 
                                    }}
                                  >
                                    {row.roi}%
                                  </Typography>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Stack>
              </Grid>
            </Grid>
          )}
      
          {/* Müşteri Segmentleri Sekmesi */}
          {activeTab === 1 && (
            <Grid container spacing={4}>
              <Grid item xs={12} lg={8}>
                <Paper sx={{ p: 3, borderRadius: 2, mb: 4 }}>
                  <Typography variant="h6" gutterBottom>
                    Müşteri Segment Analizi
                  </Typography>
                  <Box sx={{ height: 350 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <RadarChart cx="50%" cy="50%" outerRadius="80%" data={segmentAnalysis}>
                        <PolarGrid />
                        <PolarAngleAxis dataKey="subject" />
                        <PolarRadiusAxis />
                        {customerSegments.map((segment, index) => (
                          <Radar 
                            key={segment.id} 
                            name={segment.name} 
                            dataKey={segment.name} 
                            stroke={segment.color} 
                            fill={segment.color} 
                            fillOpacity={0.6} 
                          />
                        ))}
                        <RechartsTooltip />
                        <Legend />
                      </RadarChart>
                    </ResponsiveContainer>
                  </Box>
                </Paper>
                
                <Paper sx={{ p: 3, borderRadius: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Segment Dağılımı
                  </Typography>
                  <Box sx={{ height: 300 }}>
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={customerSegments}
                          cx="50%"
                          cy="50%"
                          innerRadius={50}
                          outerRadius={90}
                          paddingAngle={2}
                          dataKey="customerCount"
                          label={({name, percent}) => `${name}: ${(percent * 100).toFixed(0)}%`}
                        >
                          {customerSegments.map((entry, index) => (
                            <Cell 
                              key={`cell-${index}`} 
                              fill={entry.color} 
                            />
                          ))}
                        </Pie>
                        <RechartsTooltip />
                      </PieChart>
                    </ResponsiveContainer>
                  </Box>
                </Paper>
              </Grid>
              
              <Grid item xs={12} lg={4}>
                <Paper sx={{ p: 3, borderRadius: 2, height: '100%' }}>
                  <Typography variant="h6" gutterBottom>
                    Segment Bilgileri
                  </Typography>
                  <TableContainer sx={{ maxHeight: 400 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Segment</TableCell>
                          <TableCell align="right">Müşteri Sayısı</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {customerSegments.map((segment) => (
                          <TableRow key={segment.id}>
                            <TableCell component="th" scope="row">
                              {segment.name}
                            </TableCell>
                            <TableCell align="right">{segment.customerCount.toLocaleString('tr-TR')}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
            </Grid>
          )}
      
          {/* Kampanya Listesi Sekmesi */}
          {activeTab === 2 && (
            <Grid container spacing={4}>
              <Grid item xs={12}>
                <Paper sx={{ p: 3, borderRadius: 2, mb: 4 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography variant="h6">
                      Kampanya Listesi
                    </Typography>
                    <Stack direction="row" spacing={1}>
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel id="status-filter-label">Durum</InputLabel>
                        <Select
                          labelId="status-filter-label"
                          id="status-filter"
                          value={filter.status}
                          label="Durum"
                          onChange={(e) => handleFilterChange('status', e.target.value)}
                        >
                          <MenuItem value="all">Tümü</MenuItem>
                          <MenuItem value="Aktif">Aktif</MenuItem>
                          <MenuItem value="Planlandı">Planlandı</MenuItem>
                          <MenuItem value="Tamamlandı">Tamamlandı</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel id="type-filter-label">Tip</InputLabel>
                        <Select
                          labelId="type-filter-label"
                          id="type-filter"
                          value={filter.type}
                          label="Tip"
                          onChange={(e) => handleFilterChange('type', e.target.value)}
                        >
                          <MenuItem value="all">Tümü</MenuItem>
                          {campaignTypes.map((type) => (
                            <MenuItem key={type} value={type}>{type}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel id="segment-filter-label">Segment</InputLabel>
                        <Select
                          labelId="segment-filter-label"
                          id="segment-filter"
                          value={filter.segment}
                          label="Segment"
                          onChange={(e) => handleFilterChange('segment', e.target.value)}
                        >
                          <MenuItem value="all">Tümü</MenuItem>
                          {customerSegments.map((segment) => (
                            <MenuItem key={segment.id} value={segment.id}>{segment.name}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Stack>
                  </Box>
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Kampanya</TableCell>
                          <TableCell>Tip</TableCell>
                          <TableCell>Durum</TableCell>
                          <TableCell>Başlangıç</TableCell>
                          <TableCell>Bitiş</TableCell>
                          <TableCell>Segmentler</TableCell>
                          <TableCell>Kanallar</TableCell>
                          <TableCell align="right">Erişim</TableCell>
                          <TableCell align="right">Dönüşüm</TableCell>
                          <TableCell align="right">ROI</TableCell>
                          <TableCell align="right">İşlemler</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredCampaigns.map((campaign) => (
                          <TableRow key={campaign.id}>
                            <TableCell component="th" scope="row">
                              {campaign.name}
                            </TableCell>
                            <TableCell>{campaign.type}</TableCell>
                            <TableCell>
                              <Chip 
                                label={campaign.status} 
                                color={getStatusColor(campaign.status)} 
                                size="small" 
                              />
                            </TableCell>
                            <TableCell>{campaign.startDate}</TableCell>
                            <TableCell>{campaign.endDate}</TableCell>
                            <TableCell>
                              <AvatarGroup max={3}>
                                {campaign.segments.map((segment) => (
                                  <Tooltip key={segment.id} title={segment.name}>
                                    <Avatar sx={{ bgcolor: segment.color, width: 24, height: 24 }}>
                                      {segment.name[0]}
                                    </Avatar>
                                  </Tooltip>
                                ))}
                              </AvatarGroup>
                            </TableCell>
                            <TableCell>
                              <Stack direction="row" spacing={1}>
                                {campaign.channels.map((channel, index) => (
                                  <Chip key={index} label={channel} size="small" />
                                ))}
                              </Stack>
                            </TableCell>
                            <TableCell align="right">{campaign.reach.toLocaleString('tr-TR')}</TableCell>
                            <TableCell align="right">{campaign.conversions.toLocaleString('tr-TR')}</TableCell>
                            <TableCell align="right">
                              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    fontWeight: 'bold', 
                                    color: getRoiColor(campaign.roi) 
                                  }}
                                >
                                  {campaign.roi}%
                                </Typography>
                              </Box>
                            </TableCell>
                            <TableCell align="right">
                              <Stack direction="row" spacing={1}>
                                <Tooltip title="Görüntüle">
                                  <IconButton size="small">
                                    <VisibilityIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Düzenle">
                                  <IconButton size="small">
                                    <EditIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title="Sil">
                                  <IconButton size="small">
                                    <DeleteOutlineIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Grid>
            </Grid>
          )}
        </>
      )}
    </Container>
  );
};

export default KampanyaYonetimi;
